// extracted by mini-css-extract-plugin
export default {"root":"gift_cards_store_settings_page_root__OlVem","loading_container":"gift_cards_store_settings_page_loading_container__KRgfA"};